<template>
  <div class="color-circle" :style="{background: color}" :class="{empty: !color && !color2}">
    <div class="color2" :style="{background: color2}" v-if="color2"></div>
  </div>
</template>

<script>
export default {
  name: 'color-circle',
  props: {
    color: String,
    color2: String,
  },
};
</script>

<style scoped>
  .color-circle {
    display: inline-block;
    width: 12px;
    height: 12px;
    margin-right: 8px;
    border-radius: 100%;
    overflow: hidden;
    position: relative;
  }

  .empty {
    border: 1px solid #979797;
  }

  .color2 {
    position: absolute;
    top: 0;
    left: 50%;
    width: 50%;
    height: 100%;
  }
</style>
